import { makeObservable, observable, runInAction } from "mobx";
import { ClinicService } from "@common/services";
import { RebookReservationResponse } from "@common/models/responses";

export class RebookStore {

    @observable rebookReservation: RebookReservationResponse | undefined;

    constructor() {
        makeObservable(this, undefined, {
            autoBind: true
        });
    }

    async getReservationForRebooking(clinicId: number, reservationpublicId: string) {
        await ClinicService.getReservationForRebooking(clinicId, reservationpublicId).then((response) => {
            runInAction(() => {
                this.rebookReservation = response;
            });
        })
    }
}
